shadow$provide[535] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Context:{enumerable:true, get:function() {
  return Context;
}}, DOM:{enumerable:true, get:function() {
  return DOM;
}}, Model:{enumerable:true, get:function() {
  return Model;
}}, Overlay:{enumerable:true, get:function() {
  return Overlay;
}}, Primitives:{enumerable:true, get:function() {
  return Primitives;
}}, Render:{enumerable:true, get:function() {
  return Render;
}}, Shaders:{enumerable:true, get:function() {
  return Shaders;
}}, Stage:{enumerable:true, get:function() {
  return Stage;
}}, Util:{enumerable:true, get:function() {
  return Util;
}}, e:{enumerable:true, get:function() {
  return e;
}}, mathBox:{enumerable:true, get:function() {
  return mathBox;
}}, version:{enumerable:true, get:function() {
  return version;
}}, "\u03c0":{enumerable:true, get:function() {
  return \u03c0;
}}, "\u03c4":{enumerable:true, get:function() {
  return \u03c4;
}}});
var require$_DOT__SLASH_splash_DOT_js = require("./splash.js");
var require$threestrap = require("threestrap");
var model = require("./model");
var overlay = require("./overlay");
var primitives = require("./primitives");
var render = require("./render");
var shaders = require("./shaders");
var stage = require("./stage");
var util = require("./util");
var require$threestrap_SLASH_src_SLASH_bootstrap_DOT_js = require("threestrap/src/bootstrap.js");
var require$_DOT__SLASH_context_DOT_js = require("./context.js");
const \u03c0 = Math.PI;
const \u03c4 = \u03c0 * 2;
const e = Math.E;
const Context = require$_DOT__SLASH_context_DOT_js.Context;
const version = require$_DOT__SLASH_context_DOT_js.Context.Version;
const Model = model;
const Overlay = overlay;
const Primitives = primitives;
const Render = render;
const Shaders = shaders;
const Stage = stage;
const Util = util;
const DOM = util.VDOM;
const mathBox = function(options) {
  const three = new require$threestrap_SLASH_src_SLASH_bootstrap_DOT_js.Bootstrap(options);
  if (!three.fallback) {
    if (!three.Time) {
      three.install("time");
    }
    if (!three.MathBox) {
      three.install(["mathbox", "splash"]);
    }
  }
  return three.mathbox != null ? three.mathbox : three;
};
require$threestrap_SLASH_src_SLASH_bootstrap_DOT_js.Bootstrap.registerPlugin("mathbox", {defaults:{init:true, warmup:2, inspect:true, splash:true,}, listen:["ready", "pre", "update", "post", "resize"], install(three) {
  let inited = false;
  this.first = true;
  return three.MathBox = {init:options => {
    if (inited) {
      return;
    }
    inited = true;
    const scene = (options != null ? options.scene : undefined) || this.options.scene || three.scene;
    const camera = (options != null ? options.camera : undefined) || this.options.camera || three.camera;
    this.context = new Context(three.renderer, scene, camera);
    this.context.api.three = three.three = three;
    this.context.api.mathbox = three.mathbox = this.context.api;
    this.context.api.start = () => three.Loop.start();
    this.context.api.stop = () => three.Loop.stop();
    this.context.init();
    this.context.resize(three.Size);
    this.context.setWarmup(this.options.warmup);
    this.pending = 0;
    this.warm = !this.options.warmup;
    console.log("MathBox\u00b2", version);
    three.trigger({type:"mathbox/init", version:version, context:this.context,});
  }, destroy:() => {
    if (!inited) {
      return;
    }
    inited = false;
    three.trigger({type:"mathbox/destroy", context:this.context});
    this.context.destroy();
    delete three.mathbox;
    delete this.context.api.three;
    delete this.context;
  }, object:() => this.context != null ? this.context.scene.root : undefined,};
}, uninstall(three) {
  three.MathBox.destroy();
  delete three.MathBox;
}, ready(event, three) {
  if (this.options.init) {
    three.MathBox.init();
    return setTimeout(() => {
      if (this.options.inspect && three.MathBox) {
        return this.inspect(three);
      }
    });
  }
}, inspect(three) {
  this.context.api.inspect();
  if (!this.options.warmup) {
    return this.info(three);
  }
}, info(three) {
  const fmt = function(x) {
    const out = [];
    while (x >= 1000) {
      out.unshift(("000" + x % 1000).slice(-3));
      x = Math.floor(x / 1000);
    }
    out.unshift(x);
    return out.join(",");
  };
  const info = three.renderer.info.render;
  console.log("Geometry  ", fmt(info.triangles) + " triangles  ", fmt(info.points) + " points  ", fmt(info.lines) + " lines  ", fmt(info.calls) + " draw calls  ");
}, resize(event, three) {
  return this.context != null ? this.context.resize(three.Size) : undefined;
}, pre(event, three) {
  return this.context != null ? this.context.pre(three.Time) : undefined;
}, update(event, three) {
  let camera;
  if (this.context != null) {
    this.context.update();
  }
  if ((camera = this.context != null ? this.context.camera : undefined) && camera !== three.camera) {
    three.camera = camera;
  }
  three.Time.set({speed:this.context.speed});
  this.progress(this.context.getPending(), three);
  return this.context != null ? this.context.render() : undefined;
}, post(_event, _three) {
  return this.context != null ? this.context.post() : undefined;
}, progress(remain, three) {
  if (!remain && !this.pending) {
    return;
  }
  let pending = Math.max(remain + this.options.warmup, this.pending);
  const current = pending - remain;
  const total = pending;
  three.trigger({type:"mathbox/progress", current:pending - remain, total:pending,});
  if (remain === 0) {
    pending = 0;
  }
  this.pending = pending;
  if (current === total && !this.warm) {
    this.warm = true;
    if (this.options.inspect) {
      this.info(three);
    }
  }
},});

};